/* eslint-disable */
import { useEffect, useReducer, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { CreatePageHeader } from '../../../Components/Headers';
import { FormSectionHeader } from '../../../Components/Forms';
import {
	generateImageUploadButton,
	getBase64FromFileBlob,
	imageToBase64,
	inputHelper,
} from '../../../Helpers';
import { notificationServices } from '../../../Services';
import config from './createService.config';
import assetServices from '../../../Services/AssetServices/asset.services';
import { ImageCropModal } from '@/Components/Modals/ImageCropModal';
import { modalActions } from '@/Actions';
import { connect } from 'react-redux';

const CreateCapexService = (props) => {
	const { isEdit, breadcrumbs, toggleImageCrop } = props;
	const [state, dispatch] = useReducer(config?.reducer, config?.initialState);
	const [assetCategory, setAssetCategory] = useState([]);
	const [imageFile, setImageFile] = useState(null);
	const [isDragging, setIsDragging] = useState(false);
	const [showLogoCropModal, setShowLogoCropModal] = useState(false);
	const { id } = useParams();
	const history = useHistory();

	const fetchService = async () => {
		try {
			const response = await assetServices.listCapexServiceType({
				id,
			});
			if (response?.statusCode === 200) {
				if (response?.data && response?.data?.length !== 0) {
					dispatch({
						type: 'SET_EDIT_DATA',
						payload: response?.data[0],
					});
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const fetchCategoryAsset = async () => {
		try {
			const response = await assetServices.serviceTypeCategory({
				req: { data: { type: 'SERVICE' } },
			});
			if (response?.statusCode === 200) {
				setAssetCategory(response.data?.categories);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		fetchCategoryAsset();
		if (isEdit) {
			fetchService(id);
		}
	}, []);

	const handleInput = (e) => {
		const { fieldName, fieldValue } = inputHelper(e);
		if (fieldName === 'name') {
			dispatch({
				type: 'SET_NAME',
				payload: fieldValue,
			});
		} else if (fieldName === 'sacCode') {
			dispatch({
				type: 'SET_SAC_CODE',
				payload: fieldValue,
			});
		} else if (fieldName === 'category') {
			dispatch({
				type: 'SET_CATEGORY',
				payload: fieldValue,
			});
		} else if (fieldName === 'taxApplicable') {
			dispatch({
				type: 'SET_TAX_APPLICABLE',
				payload: fieldValue,
			});
		} else if (fieldName === 'clientServiceCode') {
			dispatch({
				type: 'SET_CLIENT_SERVICE_CODE',
				payload: fieldValue,
			});
		}
	};

	const handleImageUpload = (e) => {
		const file = e.target.files[0];
		if (file) {
			setImageFile(file);
			dispatch({
				type: 'SET_IMAGE',
				payload: file,
			});
		}
	};

	const handleDragOver = (e) => {
		e.preventDefault();
		setIsDragging(true);
	};

	const handleDragLeave = () => {
		setIsDragging(false);
	};

	const handleDrop = (e) => {
		e.preventDefault();
		setIsDragging(false);

		if (e.dataTransfer.files && e.dataTransfer.files[0]) {
			const file = e.dataTransfer.files[0];
			setImageFile(file);
			dispatch({
				type: 'SET_IMAGE',
				payload: file,
			});
		}
	};

	const handleSave = async (e) => {
		e.preventDefault();
		const isValid = config.validator(state);

		if (isValid) {
			try {
				let payload = config.deserializer(state);				

				// Convert image to base64 if exists
				if (imageFile) {
					payload.image = await imageToBase64(imageFile);
				}

				let response;
				if (isEdit) {
					payload.id = id;
					response = await assetServices.updateCapexService(payload);
				} else {
					response = await assetServices.addCapexService(payload);
				}

				if (response?.statusCode === 200) {
					dispatch({ type: 'INIT' });
					history.goBack();
					notificationServices.generateNotification({
						type: 'success',
						message: 'Saved successfully',
					});
				}
			} catch (error) {
				console.error('Error saving data:', error);
				notificationServices.generateNotification({
					type: 'error',
					message: error.response?.data?.message || 'Failed to save',
				});
			}
		}
	};

	const handleCancel = () => {
		history.goBack();
	};

	const openImageCropModal = (name, file = null) => {
		// console.log('TESTTTT', name, file);
		toggleImageCrop(false, {
			name,
			file,
		});
		setShowLogoCropModal(true);
	};

	const handleImageSelect = (e) => {
		const file = e.target.files[0];
		if (file) {
			setImageFile(file);
			openImageCropModal('image', file);
		}
	};

	const handleLogoInput = (fieldName, blob) => {
		setShowLogoCropModal(false);
		if (blob) {
			setImageFile(blob);
			dispatch({
				type: 'SET_IMAGE',
				payload: blob,
			});
		}
	};

	const getImagePreview = () => {
		if (state?.image) {
			if (typeof state.image === 'string') {
				return state.image; // Assume base64 or URL string
			}
	
			if (state.image instanceof Blob) {
				return URL.createObjectURL(state.image);
			}
		}
	
		if (imageFile instanceof Blob) {
			return URL.createObjectURL(imageFile);
		}
	
		return null;
	};

	return (
		<div className='root'>
			<ImageCropModal
				localShow={showLogoCropModal}
				handleConfirm={handleLogoInput}
				handleClose={() => {
					setShowLogoCropModal(false);
				}}
			/>
			<form onSubmit={handleSave}>
				<CreatePageHeader
					heading={isEdit ? 'Edit Product' : 'Create Product'}
					handleSave={handleSave}
					handleCancel={handleCancel}
					breadcrumbs={[
						...breadcrumbs,
						{
							link: '',
							name: isEdit ? `Edit ${state?.name}` : 'Create new',
						},
					]}
					showBreadcrumbs
				/>
				<div className='container mx-auto p-4'>
					<div className='flex flex-col lg:flex-row gap-8'>
						{/* Image Upload Section - Left Side */}
						<div className='w-full lg:w-1/3'>
							<FormSectionHeader
								tooltip='Upload product image'
								sectionName='Product Image'
								imp={true}
							>
								<div
									className={`border-2 border-dashed rounded-lg p-6 text-center h-full flex flex-col items-center justify-center ${
										isDragging
											? 'border-blue-500 bg-blue-50'
											: 'border-gray-300'
									}`}
									onDragOver={handleDragOver}
									onDragLeave={handleDragLeave}
									onDrop={handleDrop}
								>
									{getImagePreview() ? (
										<div className='relative w-full'>
											<img
												src={getImagePreview()}
												alt='Preview'
												className='w-full h-auto max-h-80 mx-auto rounded object-contain'
											/>
											<button
												type='button'
												className='absolute -top-3 -right-3 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-600'
												onClick={() => {
													if (state?.image) {
														dispatch({
															type: 'CLEAR_IMAGE',
														});
													}
													setImageFile(null);
												}}
											>
												×
											</button>
										</div>
									) : (
										<div className='flex flex-col items-center justify-center space-y-4'>
											<div className='text-gray-500'>
												Drag and drop an image here, or click to select
											</div>
											<label className='cursor-pointer bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600'>
												Choose Image
												<input
													type='file'
													accept='image/png, image/jpg, image/jpeg, image/webp'
													onChange={handleImageSelect}
													className='hidden'
												/>
											</label>
										</div>
									)}
								</div>
							</FormSectionHeader>
						</div>

						{/* Form Fields Section - Right Side */}
						<div className='w-full lg:w-2/3'>
							<FormSectionHeader
								tooltip='description for the section'
								sectionName='General Details'
							>
								<div className='space-y-4'>
									<div>
										<label
											className="block text-sm font-medium text-gray-700 mb-1 after:content-['*'] after:text-red-500"
											htmlFor='serviceName'
										>
											Service Name
										</label>
										<input
											className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500'
											type='text'
											id='serviceName'
											name='name'
											onInput={handleInput}
											value={state.name || ''}
										/>
									</div>

									<div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
										<div>
											<label
												className="block text-sm font-medium text-gray-700 mb-1 after:content-['*'] after:text-red-500"
												htmlFor='sacCode'
											>
												Sac Code
											</label>
											<input
												className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500'
												type='text'
												id='sacCode'
												name='sacCode'
												onInput={handleInput}
												value={state.sacCode || ''}
											/>
										</div>

										<div>
											<label
												className="block text-sm font-medium text-gray-700 mb-1 after:content-['*'] after:text-red-500"
												htmlFor='category'
											>
												Category
											</label>
											<select
												className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500'
												id='category'
												name='category'
												onChange={handleInput}
												value={
													state.category || ''
												}
											>
												<option value=''>
													--Select--
												</option>
												{assetCategory.map(
													(category) => (
														<option
															key={category.id}
															value={category.id}
														>
															{category.value}
														</option>
													)
												)}
											</select>
										</div>
									</div>

									<div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
										<div>
											<label
												className="block text-sm font-medium text-gray-700 mb-1 after:content-['*'] after:text-red-500"
												htmlFor='taxApplicable'
											>
												Tax Applicable (GST)
											</label>
											<input
												className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500'
												type='text'
												id='taxApplicable'
												name='taxApplicable'
												onInput={handleInput}
												value={
													state.taxApplicable ?? ''
												}
											/>
										</div>

										<div>
											<label
												className='block text-sm font-medium text-gray-700 mb-1'
												htmlFor='clientServiceCode'
											>
												Client Service Code
											</label>
											<input
												className='w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500'
												type='text'
												id='clientServiceCode'
												name='clientServiceCode'
												onInput={handleInput}
												value={
													state.clientServiceCode ||
													''
												}
											/>
										</div>
									</div>
								</div>
							</FormSectionHeader>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {
    toggleImageCrop: modalActions.toggleImageCrop,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCapexService);